import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import * as _ from "lodash";
import swal from "sweetalert2";
import { Combo2Service } from "../../../services/index";
import { SalesPlanService } from "../../../services/salesplan.service";

@Component({
  selector: "sales-Plan-Entry",
  templateUrl: "./salesPlanEntry.html",
})
export class salesPlanEntry implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  dataIncharger: any = [];
  mode: string;
  dataAgent: any = [];
  inchargerTotal: any = [];
  agentTotal: any = [];
  agentInchargerTotal: any = [];
  seasonDataList: any = [];
  groupedInchargers: any;
  inch = [];
  dataList = [];
  finyearCtrl: FormControl = new FormControl();
  isLoadMask: Promise<any>;
  loadingIndicator: boolean;
  gridOptions: any;
  seasonList = [];
  seasonfinList = [];
  agentList = [];
  inchargerList = [];
  inchargers = [];
  exceldata: any;
  totalseason_target: string;
  filter = {
    fin_id: "",
    finyear: "",
  };
  columns = [];
  toggleCol = [];
  finyearList: any;

  constructor(
    private salesPlan: SalesPlanService,
    private combo2Service: Combo2Service
  ) {
    $("#tableMain").on("click", "tr.breakrow", function () {
      $(this).nextUntil("tr.breakrow").slideToggle(500);
    });
    this.loadingIndicator = true;
  }

  ngOnInit(): void {
    this.columns = [];
    this.finyearCombo();
    this.salesPlanEntryList();
    this.loadSeasonList();

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };

    this.toggleCol = Object.assign({}, this.columns);
  }

  finyearCombo() {
    this.combo2Service.finyearCombo().then((res: any) => {
      this.finyearList = res.data;
      this.finyearCtrl.setValue(res.data[0].fin_id);
    });
  }
  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      this.filter.finyear = fitem["finyear"];
      return fitem["finyear"];
    }
    return "";
  }

  loadSeasonList() {
    let that = this;
    that.salesPlan.getSeasonSalesPlanEntry(this.filter).then(function (res) {
      that.seasonList = res;
      that.salesPlanMasterEntry();
    });
  }
  onEnterKeyPressed() {
    let idNum = event.target["id"];
    idNum = Number(idNum.substr(10)) + 1;

    setTimeout(() => {
        $('#' + "mat-input-" + idNum).focus();
    }, 100);

}
  salesPlanEntryList() {
    $("a[id^=show_]").click(function (event) {
      $("#extra_" + $(this).attr("id").substr(5)).slideToggle("slow");
      event.preventDefault();
    });
  }

  GetValue(mode) {
    this.mode = mode;
    this.inch = [];
    this.dataIncharger = [];
    this.dataAgent = [];
    this.groupedInchargers = _.groupBy(this.agentList, "incharger");

    let seasonLength = this.seasonList.length;
    var count = 0;

    var countInput = document.querySelectorAll(".mainValue").length;
    let startId = document.getElementsByClassName("mainValue")[0].id;
    let startCount = Number(startId.substr(10));
    countInput = countInput - 1 + startCount;

    for (var i = startCount; i <= countInput; i++) {
      var child = (<HTMLInputElement>document.getElementById("mat-input-" + i))
        .value;
      this.inch.push(child);
    }

    this.inchargers.forEach((el) => {
      var obj = {};
      for (let i = 0; i < this.seasonList.length; i++) {
        if (this.inch[count] == "") {
          this.inch[count] = 0;
        }
        obj[this.seasonList[i].season] = this.inch[count];
        count += 1;
      }
      this.dataIncharger[el] = [];
      this.dataIncharger[el].push(obj);
      let agentLength = this.groupedInchargers[el].length;

      let nextInch = seasonLength * agentLength;
      let AgentCount = count;
      // let agent = -1;
      count = count + nextInch;

      this.groupedInchargers[el].forEach((el1) => {
        var obj1 = {};
        for (let i = 0; i < seasonLength; i++) {
          if (this.inch[AgentCount] == "") {
            this.inch[AgentCount] = 0;
          }
          obj1[this.seasonList[i].season] = this.inch[AgentCount];
          AgentCount += 1;
        }
        // agent += 1;
        this.dataAgent[el1.name] = [];
        this.dataAgent[el1.name].push(obj1);
      });
    });

    this.tallyAgentIncharger();
  }
  tallyAgentIncharger() {
    for (const [key, value] of Object.entries(this.dataIncharger)) {
      this.dataIncharger[key].forEach((el) => {
        var inchargerTotal = 0;
        for (let key2 in el) {
          inchargerTotal += Number(el[key2]);
        }
        this.inchargerTotal[key] = [];
        this.inchargerTotal[key] = inchargerTotal;
      });
    }
    for (const [key, value] of Object.entries(this.dataAgent)) {
      this.dataAgent[key].forEach((el) => {
        var agentTotal = 0;
        for (let key2 in el) {
          agentTotal += Number(el[key2]);
        }
        this.agentTotal[key] = [];
        this.agentTotal[key] = agentTotal;
      });
    }

    for (const [key, value] of Object.entries(this.groupedInchargers)) {
      let agentInchargerTotal = 0;
      this.groupedInchargers[key].forEach((el) => {
        for (const [key1, value] of Object.entries(this.agentTotal)) {
          if (key1 == el.name) {
            agentInchargerTotal += Number(value);
          }
        }
        this.agentInchargerTotal[key] = [];
        this.agentInchargerTotal[key] += agentInchargerTotal;
      });
    }
    // console.log(this.agentInchargerTotal);

    this.agentList.forEach((el) => {
      for (const [key, value] of Object.entries(this.dataAgent)) {
        if (key == el.name) {
          el["seasonTotal"] = value;
        }
      }
    });

    var seasonDataList = _.groupBy(this.agentList, "incharger");

    for (const [key, value] of Object.entries(seasonDataList)) {
      let i = 0;
      var seasonTotal = {};

      value.forEach((el) => {
        el.seasonTotal.forEach((el1) => {
          for (let j = 0; j < Object.keys(el1).length; j++) {
            let season = Object.keys(el1)[j];

            if (season in seasonTotal) {
              seasonTotal[season] += Number(el1[Object.keys(el1)[j]]);
            } else {
              seasonTotal[season] = 0;
              seasonTotal[season] += Number(el1[Object.keys(el1)[j]]);
            }
          }
          i++;
        });
      });
      this.seasonDataList[key] = [];
      this.seasonDataList[key].push(seasonTotal);
    }

    var mismatch = true;
    this.inchargers.forEach((el) => {
      for (let j = 0; j < this.seasonList.length; j++) {
        if (
          this.seasonDataList[el][0][this.seasonList[j].season] ==
          this.dataIncharger[el][0][this.seasonList[j].season]
        ) {
          continue;
        } else {
          mismatch = false;
          swal("Agents and Teams total mismatched");
        }
      }
    });

    if (mismatch) {
      let that = this;
      for (const [key, value1] of Object.entries(this.inchargerTotal)) {
        if (value1 == 0) {
          mismatch = false;
        }
      }

      if (mismatch == false) {
        swal({
          title:
            "Some of the cells are Zero....Are you sure to save this data?",
          type: "warning",
          focusCancel: true,
          showCancelButton: true,
          confirmButtonText: "Yes, Save it!",
          cancelButtonText: "No, want to change",
        }).then(function () {
          that.onSaveSalesPlanDetails();
        });
      } else {
        that.onSaveSalesPlanDetails();
      }
    }

    //seasonTotal = seasonWiseTotal
    //dataAgent = agentWisetotal data
    //dataIncharger = InchargerWiseTotalData
  }
  onSaveSalesPlanDetails() {
    var dataInchargers = [];
    for (var obj in this.dataIncharger) {
      let object = {
        team: "",
        data: [],
      };
      object.team = obj;
      object.data = this.dataIncharger[obj];

      dataInchargers.push(object);
    }
    console.log(this.agentList);
    console.log(this.dataIncharger);
    let params = {
      dataIncharger: JSON.stringify(dataInchargers),
      agentSeasonData: JSON.stringify(this.agentList),
      fin_id: this.filter.fin_id,
    };

    let that = this;

    that.isLoadMask = that.salesPlan
      .onSaveSalesPlanDetails(params)
      .then(function (res: any) {
        if (res) {
          that.resetTable("");
          swal("Sales Plan for " + that.filter.finyear + " Saved Successfully");
        }
      });
  }
  editSalesPlan(mode) {
    this.mode = mode;

    let agentInchargersLength = document.getElementsByClassName("names").length;

    let params = {
      fin_id: this.filter.fin_id,
    };

    let that = this;

    that.isLoadMask = that.salesPlan
      .editSalesPlan(params)
      .then(function (res: any) {
        that.resetTable(mode);
        for (let i = 0; i < agentInchargersLength; i++) {
          let agentsInchargerName = (<HTMLElement>(
            document.getElementsByClassName("names")[i].children[0]
          )).innerText.trim();

          // let agentsInchargerName = ((<HTMLElement>document.getElementsByClassName("names")[i]).innerText).trim();
          let agentsIncharger = (<HTMLElement>(
            document.getElementsByClassName("names")[i]
          )).nextElementSibling;

          let idStart = Number(
            (<Element>agentsIncharger.childNodes[1]).children[0].id.substr(10)
          );

          res.forEach((el) => {
            let totalCount = that.seasonList.length + idStart;
            if (el.agents == agentsInchargerName) {
              for (let i = idStart; i < totalCount; i++) {
                let index = i - (idStart - 1);
                (<HTMLInputElement>(
                  document.getElementById("mat-input-" + i)
                )).value = el["a" + index];
              }
            }
          });
        }
      });
  }
  resetTable(mode) {
    this.mode = mode;
    var countInput = document.querySelectorAll(".mainValue").length;
    let startId = document.getElementsByClassName("mainValue")[0].id;
    let startCount = Number(startId.substr(10));
    countInput = countInput - 1 + startCount;

    for (var i = startCount; i <= countInput; i++) {
      (<HTMLInputElement>document.getElementById("mat-input-" + i)).value = "0";
    }
  }

  salesPlanMasterEntry(): void {
    let params = {
      filter: JSON.stringify(this.filter),
    };

    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
      data: [],
    };

    that.isLoadMask = that.salesPlan
      .salesPlanMasterEntry(params)
      .then(function (res: any) {
        that.agentList = res;
        that.inchargerList = Array.from(
          new Set(that.agentList.map((el) => el.incharger))
        );
        that.inchargers = JSON.parse(JSON.stringify(that.inchargerList));
        that.inchargerList["seasonList"] = that.seasonList;
      });
  }

  ngOnDestroy() {
    this.salesPlan;
    this.combo2Service;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/salesPlanMasterReport/salesPlanEntry.ts